import {madnes_fill_range, madnes_join} from "../framework/src/engine/madnes/madnes";

var in_smoke_pos = 0;
var lines = new Array();

var render_move_per_sec = 16; // Symbolu za sekundu
var render_move_per_sec_free = 26; // Symbolu za sekundu ve free spinu

export const cylinder_pos = [];
cylinder_pos[0] = 312;
cylinder_pos[1] = 640;
cylinder_pos[2] = 966;


var freepanelpos = 200;


export const icons = {
    "symbol_Cherry":{
        stop: [0],
        anim: madnes_join(madnes_fill_range(0, 35),[0])
    },
    "symbol_Blue7":{
        stop: [0],
        anim: madnes_join(madnes_fill_range(0, 35),[0])
    },

    "symbol_BlueBar":{
        stop: [0],
        anim: madnes_join(madnes_fill_range(0, 35),[0])
    },
    "symbol_Red7":{
        stop: [0],
        anim: madnes_join(madnes_fill_range(0, 35),[0])
    },
    "symbol_RedBar":{
        stop: [0],
        anim: madnes_join(madnes_fill_range(0, 35),[0])
    },
    "symbol_White7":{
        stop: [0],
        anim: madnes_join(madnes_fill_range(0, 35),[0])
    },
    "symbol_WhiteBar":{
        stop: [0],
        anim: madnes_join(madnes_fill_range(0, 35),[0])
    },

    "symbol_Diamond":{
        stop: [0],
        anim: madnes_join(madnes_fill_range(0, 59),[0])
    },
    "symbol_Star":{
        stop: [0],
        anim: madnes_join(madnes_fill_range(0, 59),[0])
    },
}

export const icons_tmp = new Array();

export const symbols = new Array();
symbols[0] = -1;
symbols[1] = -1;
symbols[2] = -1;


export  const last_symbol = new Array();
last_symbol[0] = -1;
last_symbol[1] = -1;
last_symbol[2] = -1;


var reels_lenghts = new Array();
var reels_pos = new Array();

var img_laoder;

var diry = new Array();

var smoke_manager, smoke_emitter;


// function init_game(dname, config)
// {
// 	madnes_load_init("nine_stars", config);
//
// 	madnes_set_page_bg(dname, imgsPath + "web/background.png");
//
// 	madnes_set_texture_version(13);
//
// 	madnes_set_ico_size(350, 244 - 60);
//
//
// 	madnes_set_win_factors(25, 50, 125);
// 	madnes_set_native_sceen_size(1280, 720);
// 	//madnes_set_native_sceen_size(1280, 800);
//
// 	madnes_show_money_pos_y = he * 0.44
//
//
//     for(var i in to_load_json)
//     {
//         if(infotexts_languages.indexOf(lang) === -1)
//         {
//             to_load_json[i] = to_load_json[i].replace("{l}", def_lang);
//         }
//
//         madnes_add_json(i, to_load_json[i]);
//     }
//
// 	for(var i in to_load_audio)
// 	{
// 		madnes_add_audio(i, to_load_audio[i]);
// 	}
//
// 	for(var i in to_load)
// 	{
// 		madnes_add_to_load(i, to_load[i]);
// 	}
//
// 	for(var i in to_load_fonts)
// 	{
// 		madnes_add_font_to_load(i, to_load_fonts[i]);
// 	}
// 	/*
// 	var timestle = {
// 		font: "20px Arial",
// 		fill: "#636363",
// 		align: "left",
// 		boundsAlignH: "left",
// 		boundsAlignV: "top",
// 		wordWrap: false,
// 		wordWrapWidth: 300
// 	}
// 	madnes_set_time_style(timestle);
// 	*/
// 	madnes_set_sprite('_sprite', 350, 244);
// 	madnes_set_sprite('_blur', 350, 244);
//
// 	madnes_set_sprite('bigwin_background_sprite', 1280 / 2, 500 / 2);
// 	madnes_set_sprite('bigwin_x2_background_sprite', 798, 340);
//
// 	madnes_set_default_volume(0.8);
// 	/*
// 	madnes_set_audio_volume("BACKGROUND", 0);
// 	madnes_set_audio_volume("FS_START", 0.6);
// 	madnes_set_audio_volume("Reel_spin", 0.6);
// 	madnes_set_audio_volume("FS_BG", 0.6);
// 	*/
//
// 	madnes_set_printdesk_function(ninestars_print_desk);
// 	madnes_set_updatedesk_function(ninestars_print_reels);
// 	madnes_set_rotate_function(ninestars_rotate_run);
//
// 	madnes_set_infomenu_init_function(ninestars_infomenu_init);
// 	madnes_set_infomenu_open_function(ninestars_infomenu_open);
// 	madnes_set_infomenu_close_function(ninestars_infomenu_close);
// 	madnes_set_infomenu_update_function(ninestars_infomenu_update);
// 	madnes_set_infomenu_left_function(ninestars_infomenu_left);
// 	madnes_set_infomenu_right_function(ninestars_infomenu_right);
//
// 	// madnes_set_coin_values_init(function (currency)
// 	// {
// 	// 	if (currency === "PLN")
// 	// 	{
// 	// 		coin_values = [0.1, 1];
// 	// 	} else
// 	// 	{
// 	// 		madnes_coin_values_init(currency);
// 	// 	}
// 	// });
//
// 	madnes_init(dname);
// }

